import { omit } from 'lodash'
import { objectReducer, objectMap, queryName } from 'utils'
import { FETCH_USERS, FETCH_TOP_FLIRTS_SUCCESS, SEE_LIST, HIDE_LIST } from './types'
import { ADD_FRIEND_SUCCESS, REMOVE_FRIEND_SUCCESS } from '../userProfile/types'
import { FETCH_MY_PROFILE_SUCCESS } from '../myProfile/types'

const k = ({ meta }) => queryName(meta.params)
const mediaModify = a => ({ ...a, media: [{ ...a.media[0], adultRating: Math.ceil(Math.random() * 3) }] })
const mediaMap = sessionStorage.randomRatings ? mediaModify : e => e

const usersReducer = objectReducer(
  FETCH_USERS,
  {},
  {
    fetch: (data, state, action, key = k(action)) => ({
      [key]: {
        ...(state[key] || {}),
        loading: (state?.[key]?.loading || []).concat(action.meta.params.pageNum || 1),
      },
    }),
    success: ({ accounts, currentPageNumber, currentSearchId, totalPagesCount }, state, action, key = k(action)) => {
      // reset to empty object if we had searchId before and it changed
      const old = state[key] || {}
      const item = old.searchId && old.searchId != currentSearchId ? {} : old
      return {
        [key]: {
          ...item,
          searchId: currentSearchId,
          totalPages: totalPagesCount,
          loading: (item.loading || []).filter(e => e != (action.meta.params.pageNum || 1)), // use request page in order to refetch
          pages: {
            ...item?.pages,
            [currentPageNumber || 1]: accounts.map(mediaMap),
          },
        },
      }
    },
    extra: (state, { user, type, meta, payload }) => {
      if (type == ADD_FRIEND_SUCCESS || type == REMOVE_FRIEND_SUCCESS) {
        const inHotlist = type === ADD_FRIEND_SUCCESS
        return objectMap(state, (search, name) =>
          /^(loading|loaded|error)$/.test(name)
            ? name
            : {
                ...search,
                pages: objectMap(search.pages, users => users.map(u => (u.id != user.id ? u : { ...u, inHotlist }))),
              }
        )
      }
      if (type == FETCH_TOP_FLIRTS_SUCCESS) {
        return { ...state, 'filters=flirts': { pages: { 1: payload } } }
      }
      if (type == FETCH_MY_PROFILE_SUCCESS && !meta?.silent) {
        return {}
      }
      if (type == SEE_LIST || type == HIDE_LIST) {
        const { path } = meta
        const watching = (state[path]?.watching || 0) + (type == SEE_LIST ? 1 : -1)

        return watching ? { ...state, [path]: { ...state[path], watching } } : omit(state, path)
      }
      return state
    },
  }
)
export default usersReducer
